import { SizeType } from '@goldcast/player-config/src/types/asset-types';

export enum CustomizerMenuType {
  Captions = 'Captions',
  Templates = 'Templates',
  Layout = 'Layout',
  Background = 'Background',
  Speakers = 'Speakers',
  Translation = 'Translation',
  Images = 'Images',
  AI = 'AI',
  PromptOverride = 'PromptOverride',
  Videos = 'Videos',
  Audio = 'Audio',
  Overlays = 'Overlays',
  Versioning = 'Versioning'
}

export enum TemplatesPopupTabs {
  Preset = 'Preset',
  MyTemplates = 'My Templates'
}

export const TEMPLATES_POPUP_TABS: { name: TemplatesPopupTabs; showDefaultOnly?: boolean }[] = [
  {
    name: TemplatesPopupTabs.Preset,
    showDefaultOnly: true
  },
  {
    name: TemplatesPopupTabs.MyTemplates,
    showDefaultOnly: false
  }
];

export const TEMPLATES_REVAMP_TABS = [
  { id: TemplatesPopupTabs.MyTemplates, label: TemplatesPopupTabs.MyTemplates, trackingId: 'templates-tab-my' },
  { id: TemplatesPopupTabs.Preset, label: TemplatesPopupTabs.Preset, trackingId: 'templates-tab-preset' }
];

export const PRESET_SECTIONS: { label: string; ratio: string; size: SizeType }[] = [
  { label: 'Landscape', ratio: '16:9', size: 'LANDSCAPE' },
  { label: 'Vertical', ratio: '9:16', size: 'PORTRAIT' },
  { label: 'Square', ratio: '1:1', size: 'SQUARE' }
];

// Menu types that render using PopoverCard.
// Add a type here when migrating a popup to the standard panel — ClipCustomizerMenu
// reads this set to apply consistent top positioning without per-popup conditionals.
export const STANDARD_PANEL_MENU_TYPES = new Set<CustomizerMenuType>([
  CustomizerMenuType.Overlays,
  CustomizerMenuType.Templates,
  CustomizerMenuType.Versioning,
  CustomizerMenuType.Layout
]);
